import 'src/styles/ui/input.css';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Input Component - text-like field (text, date, time, number) with the
 * app's rounded field styling. All native input props pass through.
 */
const Input = ({ className, ...props }) => (
  <input className={classNames('input-field', className)} {...props} />
);

Input.propTypes = {
  className: PropTypes.string,
};

Input.defaultProps = {
  className: null,
};

export default Input;
